import Flash from './flash'
export default Flash
